import React from 'react';

interface ArretePerilsContentProps {
  features: {properties: {address: string}, geometry: {type: string, coordinates: number[]}}[];
}

const ArretePerilsContent: React.FC<ArretePerilsContentProps> = ({ features }) => {
  if (!features || features.length === 0) {
    return (
      <div style={{ marginBottom: '16px', color: '#666', fontStyle: 'italic', textAlign: 'center', padding: '20px' }}>
        Aucune information disponible
      </div>
    );
  }

  return (
    <>
      {features.map((feature, index) => {
        const properties = feature.properties || {};
        const address = properties.address || '';


        return (
          <div key={index}>
            {address && (
              <div style={{ marginBottom: '16px' }}>
                <strong style={{ color: '#333' }}>Adresse:</strong> {String(address)}
              </div>
            )}
          </div>
        )
      })}
    </>
  );
};

export default ArretePerilsContent;
